import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import useHighcharts from '../UseHighcharts';
import usePrevious from '../UsePrevious';
import { getEventsConfig } from '../../utils/events';
import getModifiedProps from '../../utils/getModifiedProps';

var useManualEventHandlers = function useManualEventHandlers(props, target) {
  var Highcharts = useHighcharts();
  var eventHandlers = getEventsConfig(props);
  var previousEventHandlers = usePrevious(eventHandlers);
  var modifiedEvenHandlers = getModifiedProps(previousEventHandlers, eventHandlers);

  if (modifiedEvenHandlers !== false) {
    Object.keys(modifiedEvenHandlers).forEach(function (eventName) {
      if (previousEventHandlers) {
        var oldHandler = previousEventHandlers[eventName];

        if (oldHandler) {
          Highcharts.removeEvent(target, eventName, oldHandler);
        }
      }

      var newHandler = modifiedEvenHandlers[eventName];

      if (newHandler) {
        Highcharts.addEvent(target, eventName, newHandler);
      }
    });
  }
};

export default useManualEventHandlers;